import React, { useEffect, useContext, useState, Fragment } from 'react';
import axios from 'axios';
import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Formulario from '../../componentes/formulario/Formulario';
import FormRow from '../../componentes/formulario/FormRow';
import FormInput from '../../componentes/formulario/FormInput';
import { Alert } from '../../componentes/ui/Alert';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';
import Spinner from 'react-bootstrap/Spinner';
import { getTitle, getDecodedCookie, getApiUrl } from '../../helpers/helperApp';
import useLogicForm from '../../hooks/useLogicForm';
import { LoginContext } from '../../hooks/context/LoginContext';
import { alertService } from '../../services/alertservice';
import Section from '../../componentes/ui/Section';
import MiDataTable from '../../componentes/ui/MiDataTable';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import ClientReferences from './ClientReferences';
import ReferencesFinder from './ReferencesFinder';
import SupplierReferences from './SupplierReferences';
import Informes from '../../componentes/formulario/informes/Informes';


function Suppliers(props) {

    const {
        registrosPrin, saveRegistrosPrin, formularioPrin, saveFormularioPrin,
        handleInputForm, handleLastReg, handleEditRegPrin, loadingTable,
        saveLoadingTable, loadReg, regIniciales, handleDeleteItemPrin,
        handleSubmitPrin, resetFormPrin
    } = useLogicForm();

    const { validateSesion, socket, confApp, saveConfApp, getConfApp, apiKey } = useContext(LoginContext);

    // Usamos confApp del contexto directamente para evitar desincronización
    const confPantalla = confApp;

    const [tieneNivel, saveTieneNivel] = useState(true);
    const [estadoFormPrin, saveEstadoFormPrin] = useState("");
    const [estadoFormHijo, saveEstadoFormHijo] = useState("");
    const [activeSaveBtns, saveActiveSaveBtns] = useState("");

    // Estado para controlar la carga inicial de configuración
    const [initLoading, setInitLoading] = useState(true);

    //  Validación de sesión y carga de configuración si falta
    useEffect(() => {
        let isMounted = true;
        const init = async () => {
            try {
                // 1. Validar sesión
                const sessionResponse = await validateSesion(props);
                if (!isMounted) return;

                if (sessionResponse === 1) {
                    saveTieneNivel(true);

                    // Si no hay configuración o faltan artículos, intentar cargarla
                    if (!confApp || !confApp.articulos) {
                        console.log("Suppliers: Configuración incompleta, cargando desde API...");
                        const confResponse = await getConfApp();
                        if (confResponse?.msg) {
                            saveConfApp(confResponse.msg);
                        }
                    }
                } else if (sessionResponse === 0) {
                    saveTieneNivel(false);
                }
            } catch (error) {
                console.error("Suppliers: Error en inicialización:", error);
            } finally {
                if (isMounted) setInitLoading(false);
            }
        };

        init();

        return () => {
            isMounted = false;
            if (socket) {
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" });
            }
            document.body.classList.remove("sidebar-open");
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Carga de datos cuando la configuración está lista
    useEffect(() => {
        if (confPantalla?.articulos) {
            document.title = getTitle(confPantalla.config.trad, confPantalla.articulos.title);
            saveEstadoFormPrin(confPantalla.articulos.padre.estadoform);

            // Cargar registros si está vacío
            if (!registrosPrin || registrosPrin.length === 0) {
                saveLoadingTable(true);       
                //regIniciales(saveRegistrosPrin, confPantalla.articulos.padre.urls);
                const fetchArticulos = async () => {
                    try {
                        const formData = new FormData();
                        formData.append('validacion', apiKey());
                       const response = await axios.post(`${getApiUrl(window.location.origin)}/articulos/getArticulos`, formData);
                        console.log(formData);

                        if (response.data) {
                            saveRegistrosPrin(response.data);
                        }
                    } catch (error) {
                        console.error("Error cargando artículos:", error);
                        alertService.error("Error al cargar los artículos");
                    } finally {
                        saveLoadingTable(false);
                    }
                };
                fetchArticulos();

                saveFormularioPrin(confPantalla.articulos.padre.modelform);
            }

            // Deep linking
            if (props.location.state && ("idPrin" in props.location.state || "idHijo" in props.location.state)) {
                handleLastReg(
                    props.location.state.idPrin,
                    props.location.state.idHijo,
                    confPantalla.articulos.padre.urls,
                    confPantalla.articulos.hijo.urls,
                    confPantalla.articulos.padre.tabla,
                    props.location.state.estadoFormPrin,
                    saveEstadoFormPrin,
                    saveEstadoFormHijo
                );
            }
        }
    }, [confPantalla]); // Se ejecuta cuando confPantalla (confApp) cambia/se carga



    // Si estamos cargando configuración inicial, mostramos loading
    if (initLoading && (!confPantalla || !confPantalla.articulos)) {
        return (
            <div className="App wrapper">
                <LoadingPage />
            </div>
        );
    }
    console.log(registrosPrin);
    if (!tieneNivel) {
        return (
            <div className="App wrapper">
                <Menusup props={props} />
                <Sidebar props={props} />
                <div className="content-wrapper">
                    <section className="content">
                        <PermissionRefused traduction={confPantalla?.config?.trad?.components?.permissionrefused} />
                    </section>
                </div>
            </div>
        );
    }

    return (
        <div className="App wrapper">
            <div>
                {loadReg && (
                    <div className="alertFullWhite">
                        <Spinner animation="border" />
                    </div>
                )}
                <Alert fondo={!loadReg} />
            </div>

            <Fragment>
                <Menusup props={props} />
                <Sidebar props={props} />
            </Fragment>

            <div className="content-wrapper">
                <div className="content-header"></div>
                <section className="content">
                    {confPantalla?.articulos ? (
                        <Section
                            titulo="Proveedores"
                            icono="fas fa-boxes-stacked"
                            col={12}
                            idPrin={formularioPrin.id}
                        >
                            <Formulario
                                estadoForm={estadoFormPrin}
                                loading={loadReg}
                                btnNew={false}
                                btnSave={false}
                                btnSaveAndNew={false}
                                btnDelete={false}
                                btnClone={false}
                                formulario={formularioPrin}
                                resetForm={e => resetFormPrin(confPantalla.articulos.padre.modelform, true, confPantalla.articulos.padre.tabla)}
                            >

                                <Informes
                                    select={confPantalla.articulos.padre.controles.informes.select}
                                    formulario={formularioPrin}
                                    loadReg={loadReg ? true : false}
                                    estadoForm={estadoFormPrin}
                                    traduction={confPantalla.config.trad.components}
                                />
                                <hr className="separator" />
                                <Tabs defaultActiveKey="tab1" id="tab1">
                                    <Tab eventKey="tab1" title="Referencias Freiremar">

                                        <ClientReferences articleName={formularioPrin.cod1} articleId={formularioPrin.id} onBlur={null}></ClientReferences>

                                    </Tab>
                                    <Tab eventKey="tab2" title="Referencias proveedor">

                                        <SupplierReferences articleName={formularioPrin.cod1} articleId={formularioPrin.id} onBlur={null}></SupplierReferences>

                                    </Tab>
                                    <Tab eventKey="tab3" title="Buscador referencias Freiremar">

                                        <ReferencesFinder articleName={formularioPrin.cod1} articleId={formularioPrin.id} onBlur={null}></ReferencesFinder>

                                    </Tab>
                                </Tabs>
                            </Formulario>

                            <MiDataTable
                                id="table-suppliers"
                                data={registrosPrin}
                                columnas={confPantalla.articulos.padre.datatable.columns}
                                formulario={formularioPrin}
                                loadingTable={loadingTable}
                                saveLoadingTable={saveLoadingTable}
                                buttons={true}
                                handleEditReg={e => handleEditRegPrin(e, confPantalla.articulos.padre.urls, confPantalla.articulos.hijo.urls, confPantalla.articulos.padreshijos, confPantalla.articulos.hijo.modelform, confPantalla.articulos.padre.tabla)}
                                pagelength={confPantalla.articulos.padre.datatable.pagelength}
                                searching={confPantalla.articulos.padre.datatable.searching}
                                ordering={confPantalla.articulos.padre.datatable.order}
                                paging={confPantalla.articulos.padre.datatable.paging}
                                select={confPantalla.articulos.padre.datatable.select}
                                columnactions={confPantalla.articulos.padre.datatable.columnactions.title}
                                traduction={confPantalla.config.trad.components.datatable}
                                estadoForm="readonly"
                            />
                        </Section>
                    ) : (
                        <div className="alert alert-danger">
                            Error: Configuración no cargada. Por favor, recargue la página.
                        </div>
                    )}
                </section>
            </div>
        </div>
    );
}

export default Suppliers;
